import { jsxs as w, jsx as t } from "react/jsx-runtime";
import { withManagedProps as f } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as p } from "@made-people/react-prop-guard";
import u from "react";
import { Drawer as y } from "@made-people/blueprint-drawer";
import { notifyMeFormBlueprint as D, notifyMeDrawerBlueprint as I } from "./index-blueprint.es.js";
import { inputFieldSharedSchema as E, InputField as T } from "@made-people/blueprint-form";
import { toast as h } from "sonner";
import { buttonAsButtonSchema as B, ButtonAsButton as F } from "@made-people/blueprint-button";
import { overlayEventEmitter as k } from "@made-people/blueprint-overlay";
import { useTranslate as g } from "@made-people/grease-translations";
import { useBackInStockMethod as x } from "@made-people/grease-back-in-stock";
import { useUpdateCart as z } from "@made-people/grease-cart";
import "@made-people/blueprint";
const M = e.object({
  variants: e.custom().optional(),
  submitButtonVariants: B.optional(),
  inputSettings: E.optional(),
  placeholder: e.string().optional()
}), H = f(
  "NotifyMeForm",
  p(
    M,
    ({ variants: o, submitButtonVariants: r, inputSettings: c }) => {
      const { execute: a, loadingState: l, error: m } = x("subscribe"), { outOfStockItemId: i } = z(), b = D.styles(o), n = g(), [s, N] = u.useState("");
      if (!i)
        return;
      const v = async (d) => {
        if (d.preventDefault(), !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)) {
          console.error("Invalid email");
          return;
        }
        if (await a({ email: s, subscribeItemId: i }), m) {
          h.error(n("Notify_Me_Error_Toast_Heading"), {
            description: n("Notify_Me_Error_Toast_Description")
          });
          return;
        }
        h.success(
          n("Notify_Me_Success_Toast_Heading", {
            email: s
          }),
          {
            description: n("Notify_Me_Success_Toast_Description", {
              email: s
            })
          }
        ), k.emit("close", { overlayId: "notify-me" });
      };
      return /* @__PURE__ */ w("form", { className: b.base, onSubmit: v, children: [
        /* @__PURE__ */ t(
          T,
          {
            template: "floating-label",
            type: "email",
            value: s,
            onChange: (d) => N(d.target.value),
            ...c
          }
        ),
        /* @__PURE__ */ t(
          F,
          {
            variants: {
              width: "full",
              color: "black",
              size: "md"
            },
            type: "submit",
            progress: l,
            label: n("Notify_Me_Submit_Label"),
            ...r
          }
        )
      ] });
    }
  )
), S = e.object({
  template: e.literal("drawer"),
  formSettings: M.optional(),
  drawerSettings: e.custom().optional()
}), _ = 1024, O = f(
  "NotifyMeDrawer",
  p(S, (o) => {
    const r = I.styles(), [c, a] = u.useState(!1), l = g();
    u.useEffect(() => {
      a(window.innerWidth >= _);
      const i = () => a(window.innerWidth >= _);
      return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
    }, []);
    const m = c ? "right" : "bottom";
    return /* @__PURE__ */ t(
      y,
      {
        customOverlayId: "notify-me",
        hasOverlay: !0,
        repositionInputs: !1,
        hasHandle: !0,
        variants: {
          dragHandle: { initial: "true", lg: "false" },
          rounded: { initial: "strong", lg: "none" },
          background: "white",
          direction: m
        },
        direction: m,
        ...o.drawerSettings,
        children: /* @__PURE__ */ t(y.Content, { children: /* @__PURE__ */ w("div", { className: r.contentWrapper, children: [
          /* @__PURE__ */ t("h3", { className: r.heading, children: l("Notify_Me_Heading") }),
          /* @__PURE__ */ t("span", { className: r.text, children: l("Notify_Me_Text") }),
          /* @__PURE__ */ t(H, {})
        ] }) })
      }
    );
  })
), j = e.discriminatedUnion("template", [
  S
]), X = f(
  "NotifyMe",
  p(j, (o) => {
    switch (o.template) {
      case "drawer":
        return /* @__PURE__ */ t(O, { ...o });
      default:
        return null;
    }
  })
);
export {
  X as NotifyMe,
  O as NotifyMeDrawer,
  H as NotifyMeForm,
  S as notifyMeDrawerSchema,
  M as notifyMeFormSchema,
  j as notifyMeSchema
};
//# sourceMappingURL=index.es.js.map
